const displayMapPoint = () => {

    const mapPoint = document.querySelectorAll('.point-map');

    if (mapPoint.length > 0) {
        const map = document.querySelector('#map-container img');
        let width = map.offsetWidth;
        mapPoint.forEach(function (item) {
            item.style.width = (width / 100) * 3 + 'px';
            item.style.height = (width / 100) * 3 + 'px';
        });
    }
};


export default displayMapPoint;